/*  Loop Subscription Bundle Snippet v3.4

Created and maintained by LOOP SUBSCRIPTIONS (https://apps.shopify.com/loop-subscriptions)
DO NOT modify source code of this file because
- It is an automatically generated file from LOOP SUBSCRIPTIONS backend.
- LOOP SUBSCRIPTIONS will keep releasing new versions of this file. You can check the latest version
  available by visiting Loop Admin > Bundles > Snippets > Install bundle snippet.
- Updating will replace the existing file implying that all the custom code on the existing file
  (if any) will be lost.
- If you need to make changes, please do it using our standard bundle style settings available inside each bundle details page on Loop admin portal.
If you need any help, please contact us at support@loopwork.co.
*/

const BUNDLE_LINK_PREFIX = "/a/loop_subscriptions/bundle";
const LOOP_BUNDLE_URL = "https://api-service.loopwork.co/bundleTransaction/getBundleCartDetails";
const LOOP_API_SERVICE_URL = "https://api-service.loopwork.co";
let BUNDLE_CONTAINER_CLASS = "BUNDLE_CONTAINER_CLASS";
let CART_SUBTOTAL_CLASS = "CART_SUBTOTAL_CLASS";

//dev
// const LOOP_BUNDLE_URL =
//   "https://dev-api-service.loopwork.co/bundleTransaction/getBundleCartDetails";
// const LOOP_API_SERVICE_URL = "https://dev-api-service.loopwork.co";

//prod
// const LOOP_BUNDLE_URL =
//   "https://api-service.loopwork.co/bundleTransaction/getBundleCartDetails";
// const LOOP_API_SERVICE_URL = "https://api-service.loopwork.co";

const getItemsHtmlLoop = (item, bundleQuantityMapping) => {
    let quantity = item.quantity;
    if (bundleQuantityMapping) {
        let variant = bundleQuantityMapping.find(
            (v) => v.childProductId === item.id
        );
        if (variant) {
            quantity = variant.quantity;
        }
    }
    return `<p><span style="display:block;" class="data-cart-item-selling-plan-name">${
        item.title || ""
    } x ${quantity || ""}</span></p>`;
};

const getEditCartButton = (bundleTransactionId, editBtnText = "Edit or Swap Meals") => {
    return `<button onclick="event.preventDefault(); changeBundleCartItems('${bundleTransactionId}');" style="background:none;border:none;display:flex;align-items:center;gap:3px;cursor:pointer;padding:0; text-decoration:underline;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen" viewBox="0 0 17 17">
            <path fill-rule="evenodd" d="M15.655 4.344a2.695 2.695 0 0 0-3.81 0l-.599.599-.009-.009-1.06 1.06.008.01-5.88 5.88a2.75 2.75 0 0 0-.805 1.944v1.922a.75.75 0 0 0 .75.75h1.922a2.75 2.75 0 0 0 1.944-.806l7.54-7.539a2.695 2.695 0 0 0 0-3.81Zm-4.409 2.72-5.88 5.88a1.25 1.25 0 0 0-.366.884v1.172h1.172c.331 0 .65-.132.883-.366l5.88-5.88-1.689-1.69Zm2.75.629.599-.599a1.195 1.195 0 1 0-1.69-1.689l-.598.599 1.69 1.689Z"></path>
        </svg>
        <p style="padding:0px;margin:0px;margin-top:5px">${
            editBtnText ?? "Edit or Swap Meals"
        }</p>
    </button>`;
};

const getBundleCartTableTemplateLoop = (bundleItem, index, bundleLink) => {
    return `
        <tr class="cart-item" id="CartBundleItem-${index}">
    <td class="cart-item__media">
        <a href="${bundleLink}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
          <div class="cart-item__image-container gradient global-media-settings">
            <img src="${
                bundleItem.image || ""
            }"  class="cart-item__image" alt="" loading="lazy" width="150" height="94">
          </div>
    </td>

    <td class="cart-item__details"><a href="" class="cart-item__name h4 break">${
        bundleItem.label
    }</a>
                <div class="product-option">
            ${bundleItem.items.map((item) => getItemsHtmlLoop(item)).join("")}
              <br/>
        </div>
        <div class="product-option">
         ${bundleItem.price}
        </div><dl></dl>
        <p class="product-option">${
            bundleItem.sellingPlan || ""
        }</p><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>
        ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
    </td>

    <td class="cart-item__totals right medium-hide large-up-hide">
      <div class="cart-item__price-wrapper">
        <span class="price price--end">
             ${bundleItem.price}
        </span>
      </div>
    </td>

    <td class="cart-item__quantity">
      <div class="cart-item__quantity-wrapper">
        <quantity-input class="quantity">
          <input disabled class="quantity__input" type="number" value="1" min="0">
        </quantity-input>
        <cart-remove-button>
          <a onclick="removeBundleLoop('${
              bundleItem.bundleId
          }')" class="button button--tertiary" aria-label="${
        bundleItem.label
    }" style="cursor : pointer">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
          </a>
        </cart-remove-button>
      </div>
    </td>

    <td class="cart-item__totals right small-hide">
      <div class="cart-item__price-wrapper"><span class="price price--end">
           ${bundleItem.price}
          </span></div>
    </td>
  </tr>
    `;
};

const getBundleCartDrawerTemplateLoop = (bundleItem, index, bundleLink) => {
    return `
        <tr class="cart-item" id="CartBundleItem-${index}">
          <td class="cart-item__media" style="text-align:center;">
            <img class="cart-item__image"
              src="${bundleItem.image || ""}"
              alt="${bundleItem.label}" loading="lazy" width="75" height="75">
          </td>
          <td class="cart-item__details">
            <a href="${bundleLink}"
              class="cart-item__name break">
              ${bundleItem.label || ""}
            </a>
            <dl>
              <div class="product-option">
                ${bundleItem.items
                    .map((item) => getItemsHtmlLoop(item))
                    .join("")}
                  <br/>
                  <p><span class="data-cart-item-selling-plan-name">
                    ${bundleItem.sellingPlan || ""}
                  </span></p>
              </div>
            </dl>
          </td>
          <td class="cart-item__quantity small-hide">
            ${bundleItem.quantity}
          </td>
          <td class="right medium-hide large-up-hide">
            <div class="cart-item__price-wrapper medium-up" style="display: flex; gap: 10px;">
              ${
                  bundleItem.priceWithoutDiscount !== bundleItem.price
                      ? `<span class="price price--end" style="text-decoration:line-through;">
                    ${bundleItem.priceWithoutDiscount}
                </span>`
                      : ""
              }
              <span class="price price--end" style="font-weight: 600;">
                ${bundleItem.price}
              </span>
            </div>
            ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
            <div onclick="removeBundleLoop('${
                bundleItem.bundleId
            }')" style="cursor:pointer; width: fit-content;height: 15px;display: inline-flex;flex-direction: row-reverse;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="width: 1em; height: 1em;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
            </div>
          </td>
        </tr>
    `;
};

const getBundleCartItemsDivTemplateLoop = (bundleItem, index, bundleLink) => {
    return `
        <div style="display:flex; gap:20px; justify-content: space-between;" id="CartBundleItem-${index}">
          <div style="display:flex; gap:20px;">
            <div style="text-align:center;">
              <img
                src="${bundleItem.image || ""}"
                alt="${bundleItem.label}" loading="lazy" width="75" height="75">
            </div>
            <div>
              <a href="${bundleLink}"
                 style="font-weight:600">
                ${bundleItem.label || ""}
              </a>
              <div>
                ${bundleItem.items
                    .map((item) => getItemsHtmlLoop(item))
                    .join("")}
                  <br/>
                  <p><span>${bundleItem.sellingPlan || ""}</span></p>
              </div>
            </div>
          </div>
          <div>
            ${bundleItem.quantity}
          </div>
          <div>
            <div style="display: flex; gap: 10px;">
                ${
                    bundleItem.priceWithoutDiscount !== bundleItem.price
                        ? `<span style="text-decoration:line-through;">
                        ${bundleItem.priceWithoutDiscount}
                    </span>`
                        : ""
                }
              <span style="font-weight: 600;">${bundleItem.price}</span>
            </div>
            ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
            <div onclick="removeBundleLoop('${
                bundleItem.bundleId
            }')" style="cursor:pointer; vertical-align: text-top; width: fit-content;height: 15px;display: inline-flex;flex-direction: row-reverse;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="width: 1em; height: 1em;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
            </div>
          </div>
        </div>
    `;
};

const getPresetBundleCartTemplateLoop = (bundleItem, index, bundleLink) => {
    return `
        <tr class="cart-item" id="CartBundleItem-${index}">
    <td class="cart-item__media">
        <a href="${bundleLink}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
          <div class="cart-item__image-container gradient global-media-settings">
            <img src="${
                bundleItem.image || ""
            }"  class="cart-item__image" alt="" loading="lazy" width="150" height="94">
          </div>
    </td>

    <td class="cart-item__details"><a href="${bundleLink}" class="cart-item__name h4 break">${
        bundleItem.label
    }</a>
        <div class="product-option">
            ${bundleItem.items
                .map((item) =>
                    getItemsHtmlLoop(item, bundleItem.bundleQuantityMapping)
                )
                .join("")}
              <br/>
        </div>
        <div class="product-option">
         ${bundleItem.eachBundleAmount}
        </div><dl></dl>

        <p class="product-option">${bundleItem.sellingPlan || ""}</p>
        ${
            bundleItem.discountTitle
                ? `<ul class="discounts list-unstyled" role="list" aria-label="Discount">
            <li class="discounts__discount">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                    </path>
                </svg>
                ${bundleItem.discountTitle}
            </li>
        </ul>`
                : ""
        }
    </td>

    <td class="cart-item__totals right medium-hide large-up-hide">
      <div class="cart-item__price-wrapper"><span class="price price--end">
           ${bundleItem.final_line_price}
          </span></div>
    </td>

    <td class="cart-item__quantity">
      <div class="cart-item__quantity-wrapper">
        <quantity-input class="quantity">
          <input disabled class="quantity__input" type="number" value="${
              bundleItem.bundleProductQuantity
          }" min="0">
        </quantity-input>
        <cart-remove-button>
          <a onclick="removeBundleLoop('${
              bundleItem.bundleId
          }')" class="button button--tertiary" aria-label="${
        bundleItem.label
    }" style="cursor : pointer">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
          </a>
        </cart-remove-button>
      </div>
    </td>

    <td class="cart-item__totals right small-hide">
      <div class="cart-item__price-wrapper"><span class="price price--end">
           ${bundleItem.final_line_price_currency}
          </span></div>
    </td>
  </tr>
    `;
};

const getPresetBundleCartDrawerTemplateLoop = (
    bundleItem,
    index,
    bundleLink
) => {
    return `
        <tr class="cart-item" id="CartBundleItem-${index}">
    <td class="cart-item__media">
        <a href="${bundleLink}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
          <div class="cart-item__image-container gradient global-media-settings">
            <img src="${
                bundleItem.image || ""
            }"  class="cart-item__image" alt="" loading="lazy" width="150" height="94">
          </div>
    </td>

    <td class="cart-item__details"><a href="${bundleLink}" class="cart-item__name h4 break">${
        bundleItem.label
    }</a>
                <div class="product-option">
            ${bundleItem.items
                .map((item) =>
                    getItemsHtmlLoop(item, bundleItem.bundleQuantityMapping)
                )
                .join("")}
              <br/>
        </div>
        <div class="product-option">
         ${bundleItem.eachBundleAmount}
        </div><dl></dl>

        <p class="product-option">${bundleItem.sellingPlan || ""}</p>
        ${
            bundleItem.discountTitle
                ? `<ul class="discounts list-unstyled" role="list" aria-label="Discount">
            <li class="discounts__discount">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                    </path>
                </svg>
                ${bundleItem.discountTitle}
            </li>
        </ul>`
                : ""
        }
    </td>

    <td class="cart-item__totals right medium-hide large-up-hide">
      <div class="cart-item__price-wrapper"><span class="price price--end">
           ${bundleItem.final_line_price}
          </span></div>
    </td>

    <td class="cart-item__quantity">
      <div class="cart-item__quantity-wrapper">
        <quantity-input class="quantity">
          <input disabled class="quantity__input" type="number" value="${
              bundleItem.bundleProductQuantity
          }" min="0">
        </quantity-input>
        <cart-remove-button>
          <a onclick="removeBundleLoop('${
              bundleItem.bundleId
          }')" class="button button--tertiary" aria-label="${
        bundleItem.label
    }" style="cursor : pointer">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
          </a>
        </cart-remove-button>
      </div>
    </td>

    <td class="cart-item__totals right small-hide">
      <div class="cart-item__price-wrapper"><span class="price price--end">
           ${bundleItem.final_line_price_currency}
          </span></div>
    </td>
  </tr>
    `;
};

// returns cart item key of a bundleId
const getItemKeysByBundleIdLoop = (bundleId) => {
    const cartItems = window.Loop.bundleCartAllItems;
    const data = {
        updates: {},
    };
    for (const item of cartItems) {
        const _bundleId =
            item?.properties?._bundleId ?? item?.properties?.bundleId;
        if (!_bundleId || _bundleId !== bundleId) continue;
        data.updates[item.key] = 0;
    }
    return data;
};

// removes a bundleId from cart
const removeBundleLoop = async (bundleId) => {
    const data = getItemKeysByBundleIdLoop(bundleId);
    const endpoint = `${window.Shopify.routes.root}cart/update.js`;
    await fetch(endpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    window.location.href = window.location.href;
};

const changeBundleCartItems = async (bundleTransactionId) => {
    disableEditButton();
    const currentLocale = window?.Shopify?.locale;
    const root = window?.Shopify?.routes?.root ?? "/";

    if (bundleTransactionId) {
        const _editBundleRef = `${BUNDLE_LINK_PREFIX}/change/${bundleTransactionId}`;
        if (currentLocale && root !== "/") {
            window.location.href = `/${currentLocale}${_editBundleRef}`;
        } else {
            window.location.href = _editBundleRef;
        }
    }
};

const disableEditButton = (bundleId) => {
    console.log(`disabling bundle edit button: ${bundleId}`);
    const editButttons = document.querySelectorAll(
        `loop-edit-bundle-${bundleId}`
    );
    for (const button of editButttons) {
        button.disabled = true;
    }
};

const fetchLoopBundleTransactionCartDetails = async (loopBundleGuid) => {
    const { locale } = window.Shopify;
    const _locale = locale.split("-")[0];
    const _endpoint = `${LOOP_BUNDLE_URL}/${loopBundleGuid}?locale=${_locale}`;
    const _response = await fetch(_endpoint);
    return await _response.json();
};

// Helper function to format price using Intl
const formatPrice = (amount, currencyCode = null) => {
    const currency = currencyCode || window?.Shopify?.currency?.active || "USD";
    const locale = window?.Shopify?.locale || "en";

    try {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);
    } catch (error) {
        // Fallback if Intl fails
        console.error("Error formatting price:", error);
        return `${currency} ${amount.toFixed(2)}`;
    }
};

const addExtraDetailsToBundleItemsLoop = async (bundleItems) => {
    let totalDiscount = 0;
    let currencyCode = "";

    // Get the exchange rate for currency conversion (default to 1 if not available)
    const exchangeRate = window?.Shopify?.currency?.rate || 1;

    // Get active currency code
    currencyCode = window?.Shopify?.currency?.active;

    const fetchDetailsPromises = bundleItems.map((bundleItem) =>
        fetchLoopBundleTransactionCartDetails(bundleItem.bundleId)
    );
    const allExtraDetails = await Promise.all(fetchDetailsPromises);
    for (let i = 0; i < allExtraDetails.length; ++i) {
        const extraDetails = allExtraDetails[i];
        const bundleItem = bundleItems[i];
        const quantityMapping =
            extraDetails?.variantMap?.[bundleItem.bundleId] ?? [];
        const isPresetBundleProduct = bundleItem.isPresetBundleProduct;
        const totalBundleItemsQuantity = bundleItem.items.reduce(
            (acc, item) => acc + item.quantity,
            0
        );
        let price = isPresetBundleProduct
            ? bundleItem.discounted_price
            : bundleItem.price;

        bundleItem.label = extraDetails?.label;
        bundleItem.image = extraDetails?.image;
        bundleItem.sellingPlan = extraDetails?.name;
        bundleItem.editBtnText = extraDetails.editBtnText ?? "Edit or Swap Meals";
        bundleItem.priceWithoutDiscount = formatPrice(price, currencyCode);
        bundleItem.final_line_price_currency = formatPrice(
            parseFloat(bundleItem.final_line_price),
            currencyCode
        );
        bundleItem.loopBundleId = extraDetails.loopBundleId;

        if (
            extraDetails.discountType &&
            extraDetails.discountValue &&
            !isPresetBundleProduct
        ) {
            if (extraDetails.discountType === "PERCENTAGE") {
                if (extraDetails.appliesOnEachItem) {
                    // if discount in each item
                    totalDiscount +=
                        price *
                        (parseFloat(extraDetails.discountValue) / 100) *
                        totalBundleItemsQuantity;
                    price =
                        price -
                        price *
                            (parseFloat(extraDetails.discountValue) / 100) *
                            totalBundleItemsQuantity;
                } else {
                    totalDiscount +=
                        price * (parseFloat(extraDetails.discountValue) / 100);
                    price =
                        price -
                        price * (parseFloat(extraDetails.discountValue) / 100);
                }
            } else {
                // Fixed amount discount - convert from store currency to customer's currency
                const convertedDiscountValue =
                    parseFloat(extraDetails.discountValue) * exchangeRate;

                if (extraDetails.appliesOnEachItem) {
                    // if discount in each item
                    totalDiscount +=
                        convertedDiscountValue * totalBundleItemsQuantity;
                    price =
                        price -
                        convertedDiscountValue * totalBundleItemsQuantity;
                } else {
                    totalDiscount += convertedDiscountValue;
                    price = price - convertedDiscountValue;
                }
            }
        }

        bundleItem.price = formatPrice(parseFloat(price), currencyCode);

        if (extraDetails?.productsQuantity) {
            bundleItems[i]["bundleProductQuantity"] =
                extraDetails.productsQuantity;
            bundleItems[i]["eachBundleAmount"] = formatPrice(
                parseFloat(
                    bundleItems[i].final_line_price /
                        extraDetails.productsQuantity
                ),
                currencyCode
            );
        } else {
            bundleItems[i]["bundleProductQuantity"] = 1;
            bundleItems[i]["eachBundleAmount"] = formatPrice(
                parseFloat(price / 1),
                currencyCode
            );
        }
        if (quantityMapping.length) {
            bundleItem.bundleQuantityMapping = quantityMapping;
        }
        if (isPresetBundleProduct) {
            bundleItem.productHandle = extraDetails.product_handle;
        }
    }

    removeDiscountFromSubtotalInCartLoop(totalDiscount, currencyCode);
};

const removeDiscountFromSubtotalInCartLoop = (totalDiscount, currencyCode) => {
    let targetNode = null;
    targetNode = document.querySelector(`.totals__subtotal-value`);
    if (targetNode) {
        applyDiscountByCartLineItemsLoop(
            targetNode,
            totalDiscount,
            currencyCode
        );
    }
};

function applyDiscountByCartLineItemsLoop(element, discount, currencyCode) {
    const totalLineItemsPrice = window.Loop.bundleCartAllItems.reduce(
        (acc, item) => {
            return (
                acc +
                (item.properties._isPresetBundleProduct
                    ? item.discounted_price
                    : item.price) *
                    item.quantity
            );
        },
        0
    );
    const discountedPrice = (
        (totalLineItemsPrice / 100).toFixed(2) - discount
    ).toFixed(2);

    if (!isNaN(discountedPrice)) {
        element.innerHTML = formatPrice(
            parseFloat(discountedPrice),
            currencyCode
        );
    }
}

const getBundleItemsLoop = (items) => {
    const bundleItemsMap = {};
    for (const item of items) {
        const bundleId =
            item?.properties?._bundleId ?? item?.properties?.bundleId;
        if (!bundleId || !/^([0-9a-f]{32}|[0-9A-Z]{26})$/.test(bundleId)) continue;
        if (!Object.hasOwn(bundleItemsMap, bundleId)) {
            bundleItemsMap[bundleId] = {
                bundleId,
                quantity: 1,
                price: (Number(item.price) * Number(item.quantity)) / 100,
                amount: (Number(item.price) * Number(item.quantity)) / 100,
                items: [item],
                discounted_price:
                    (Number(item.discounted_price) * Number(item.quantity)) /
                    100,
                isPresetBundleProduct: item?.properties?._isPresetBundleProduct,
                discountTitle: item?.discounts?.[0]?.title ?? "",
                final_line_price: Number(item.final_line_price) / 100,
            };
        } else {
            bundleItemsMap[bundleId].price +=
                (Number(item.price) * Number(item.quantity)) / 100;
            bundleItemsMap[bundleId].discounted_price +=
                (Number(item.discounted_price) * Number(item.quantity)) / 100;
            bundleItemsMap[bundleId].amount +=
                (Number(item.price) * Number(item.quantity)) / 100;
            bundleItemsMap[bundleId].final_line_price +=
                Number(item.final_line_price) / 100;
            bundleItemsMap[bundleId].items.push(item);
        }
    }
    return sortItemsByTitleLoop(Object.values(bundleItemsMap));
};

const sortItemsByTitleLoop = (bundles) => {
    return bundles.map((bundle) => {
        bundle.items.sort((a, b) => {
            let titleA = a.title.toUpperCase();
            let titleB = b.title.toUpperCase();
            if (titleA < titleB) {
                return -1;
            }
            if (titleA > titleB) {
                return 1;
            }
            return 0;
        });
        return bundle;
    });
};

const renderBundleItemsLoop = (bundleItems, clientId) => {
    let _parent = document.querySelector(`.${clientId}`);
    if (!_parent) {
        _parent = document.querySelector(`.${BUNDLE_CONTAINER_CLASS}`);
    }
    if (!_parent) {
        return;
    }

    for (let i = 0; i < bundleItems.length; ++i) {
        let bundleItem = bundleItems[i];
        const _bundleLink = bundleItem.isPresetBundleProduct
            ? `https://${window.Shopify.shop}/products/${bundleItem.productHandle}`
            : `${BUNDLE_LINK_PREFIX}/${bundleItem.loopBundleId}`;
        let _template = undefined;
        let hasTable = document.getElementsByTagName("table");

        if (
            bundleItem["isPresetBundleProduct"] &&
            window.location.pathname === "/cart"
        ) {
            _template = getPresetBundleCartTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else if (
            bundleItem["isPresetBundleProduct"] &&
            window.location.pathname !== "/cart"
        ) {
            _template = getPresetBundleCartDrawerTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else if (clientId.includes("drawer") && hasTable.length) {
            _template = getBundleCartDrawerTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else if (hasTable.length) {
            _template = getBundleCartTableTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else {
            _template = getBundleCartItemsDivTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        }
        _parent.innerHTML = `${_template} ${_parent.innerHTML}`;
    }
};

async function getCartItemsLoop() {
    const url = `https://${Shopify.cdnHost.split("/cdn")[0]}/cart.json`;
    const res = await (await fetch(url)).json();
    return res?.items ?? [];
}

function setupMutationLoop(_bundleItems) {
    if (!_bundleItems?.length) return;

    if (window.location.pathname.includes("/a/loop_subscriptions/bundle")) {
        return;
    }

    let previousQuantity = window.Loop.bundleCartAllItems.reduce(
        (acc, curr) => acc + curr.quantity,
        0
    );
    let timeoutId;
    const handleChanges = async () => {
        const res = await getCartItemsLoop();
        let currenctQuantity = res.reduce(
            (acc, curr) => acc + curr.quantity,
            0
        );
        if (currenctQuantity !== previousQuantity) {
            window.location.reload();
        }
    };

    let targetNodes = document.querySelectorAll("form");
    const config = { childList: true, subtree: true };

    targetNodes.forEach((targetNode) => {
        const observer = new MutationObserver(() => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(handleChanges, 500);
        });
        observer.observe(targetNode, config);
    });
}

function setupMutationIfElementDelete() {
    let firstChange = true;
    let timeoutId;
    const handleChanges = () => {
        if (firstChange) {
            firstChange = false;
        } else {
            if (
                !window.location.pathname.includes(
                    "/a/loop_subscriptions/bundle"
                )
            ) {
                firstChange = true;
                window.location.reload();
            }
        }
    };

    let targetNode = document.querySelector(".cart-container");
    if (!targetNode) {
        targetNode = document.querySelector(".cart__blocks");
    }
    if (!targetNode) {
        return;
    }

    const observer = new MutationObserver(() => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(handleChanges, 1000);
    });
    const config = { childList: true, subtree: true };
    observer.observe(targetNode, config);
}

function setupMutationOldLoop() {
    var firstChange = true;
    let targetNode = null;
    let observerNode = null;
    targetNode = document.querySelectorAll(`[data-cart-subtotal]`);
    if ((targetNode && targetNode.length > 1) || !targetNode.length) {
        observerNode = document.querySelector(`.${CART_SUBTOTAL_CLASS}`);
    } else {
        observerNode = targetNode[0];
    }

    if (!observerNode) {
        return;
    }

    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
        if (firstChange) {
            firstChange = false;
            return;
        } else {
            firstChange = true;
            setTimeout(window.location.reload(), 1000);
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(observerNode, config);
}

const initLoopBundle = async (clientId) => {
    console.log(`Loop Bundle Initialized for ${clientId}`);
    const _cartItems = window.Loop.bundleCartAllItems;
    const _bundleItems = getBundleItemsLoop(_cartItems);
    await addExtraDetailsToBundleItemsLoop(_bundleItems);
    setupMutationLoop(_bundleItems);
    renderBundleItemsLoop(_bundleItems, clientId);
};

(() => {
    const productDetailsCache = new Map();
    const productMetaDetailsCache = new Map();
    const productPageDetailsCache = new Map();
    let activeProductDetailsCard = null;

    const moneyFormatter = (() => {
        const currency = window?.Shopify?.currency?.active || "USD";
        try {
            return new Intl.NumberFormat(undefined, { style: "currency", currency });
        } catch (error) {
            return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
        }
    })();

    const formatMoneyFromCents = (cents) => moneyFormatter.format((Number(cents) || 0) / 100);
    const escapeHtmlLoopDetails = (value) =>
        String(value || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    const stripHtmlLoopDetails = (html) => {
        const doc = new DOMParser().parseFromString(String(html || ""), "text/html");
        return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
    };
    const formatMacroValueLoopDetails = (value, unit = "") => {
        const normalizedValue = String(value || "").trim();
        if (!normalizedValue) return "";
        if (!unit || normalizedValue.toLowerCase().endsWith(unit.toLowerCase())) return normalizedValue;
        return `${normalizedValue}${unit}`;
    };

    const getActiveProductDetailsQuantity = () => {
        const value =
            activeProductDetailsCard?.querySelector(".loop-form-input")?.value ||
            activeProductDetailsCard?.querySelector(".loop-form-input")?.textContent ||
            activeProductDetailsCard?.querySelector("[data-qty-value]")?.textContent ||
            "0";

        return Math.max(0, Number.parseInt(String(value).trim(), 10) || 0);
    };

    const getDisplayedProductDetailsQuantity = () => {
        const modalQuantity =
            document.querySelector("[data-loop-product-details-qty]")?.textContent ||
            document.querySelector("[data-loop-product-details-status-qty]")?.textContent ||
            "0";

        return Math.max(0, Number.parseInt(String(modalQuantity).trim(), 10) || 0);
    };

    const syncProductDetailsActionState = (quantityOverride) => {
        const modal = document.querySelector("[data-loop-product-details-modal]");
        if (!modal) return;

        const quantity =
            typeof quantityOverride === "number"
                ? Math.max(0, quantityOverride)
                : getActiveProductDetailsQuantity();
        const addButton = modal.querySelector("[data-loop-product-details-add]");
        const stepper = modal.querySelector("[data-loop-product-details-stepper]");
        const quantityLabel = modal.querySelector("[data-loop-product-details-qty]");
        const status = modal.querySelector("[data-loop-product-details-status]");
        const statusQty = modal.querySelector("[data-loop-product-details-status-qty]");
        const minusButton = modal.querySelector("[data-loop-product-details-minus]");

        if (quantityLabel) quantityLabel.textContent = String(quantity);
        if (statusQty) statusQty.textContent = String(quantity);
        if (addButton) addButton.hidden = true;
        if (stepper) stepper.hidden = false;
        if (status) {
            status.hidden = false;
            status.innerHTML =
                quantity > 0
                    ? `<span aria-hidden="true">✓</span><span>In your box · ×<span data-loop-product-details-status-qty>${quantity}</span></span>`
                    : "<span>Add to Box</span>";
        }
        if (minusButton) minusButton.disabled = quantity <= 0;
    };

    const clickActiveProductDetailsControl = (action) => {
        const currentQuantity = Math.max(getActiveProductDetailsQuantity(), getDisplayedProductDetailsQuantity());
        const nextQuantity = action === "decrease" ? Math.max(0, currentQuantity - 1) : currentQuantity + 1;
        const selectors =
            action === "decrease"
                ? [".loop-btn-input-decrease", "[data-qty-minus]"]
                : [".loop-btn-input-increase", ".loop-btn-add-product", "[data-qty-plus]", "[data-qty-quick-add]"];

        const control = selectors
            .map((selector) => activeProductDetailsCard?.querySelector(selector))
            .find(Boolean);

        control?.click();
        syncProductDetailsActionState(nextQuantity);
        setTimeout(() => syncProductDetailsActionState(nextQuantity), 80);
        setTimeout(() => syncProductDetailsActionState(nextQuantity), 500);
    };

    const ensureProductDetailsModal = () => {
        let modal = document.querySelector("[data-loop-product-details-modal]");
        if (modal) return modal;

        document.body.insertAdjacentHTML(
            "beforeend",
            `
                <div class="loop-product-details-modal" data-loop-product-details-modal hidden>
                    <button type="button" class="loop-product-details-modal__backdrop" data-loop-product-details-close aria-label="Close product details"></button>
                    <section class="loop-product-details-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="loop-product-details-title">
                        <button type="button" class="loop-product-details-modal__close" data-loop-product-details-close aria-label="Close product details">×</button>
                        <div class="loop-product-details-modal__media">
                            <img data-loop-product-details-image alt="" loading="lazy">
                        </div>
                        <div class="loop-product-details-modal__content">
                            <p class="loop-product-details-modal__eyebrow">Meal details</p>
                            <h2 id="loop-product-details-title" data-loop-product-details-title></h2>
                            <p class="loop-product-details-modal__price" data-loop-product-details-price></p>
                            <div class="loop-product-details-modal__nutrition" data-loop-product-details-nutrition hidden></div>
                            <p class="loop-product-details-modal__description" data-loop-product-details-description></p>
                            <div class="loop-product-details-modal__ingredients" data-loop-product-details-ingredients hidden></div>
                            <div class="loop-product-details-modal__actions">
                                <button type="button" class="loop-product-details-modal__add" data-loop-product-details-add>Add Meal</button>
                                <div class="loop-product-details-modal__stepper" data-loop-product-details-stepper hidden>
                                    <button type="button" data-loop-product-details-minus aria-label="Decrease quantity">−</button>
                                    <span data-loop-product-details-qty>0</span>
                                    <button type="button" data-loop-product-details-plus aria-label="Increase quantity">+</button>
                                </div>
                                <button type="button" class="loop-product-details-modal__status" data-loop-product-details-status hidden>
                                    <span>Add to Box</span>
                                </button>
                                <a class="loop-product-details-modal__link" data-loop-product-details-link href="#">View full product</a>
                            </div>
                        </div>
                    </section>
                </div>
            `
        );

        modal = document.querySelector("[data-loop-product-details-modal]");
        modal.querySelectorAll("[data-loop-product-details-close]").forEach((button) => {
            button.addEventListener("click", closeProductDetailsModal);
        });
        modal.querySelector("[data-loop-product-details-add]")?.addEventListener("click", () => {
            clickActiveProductDetailsControl("increase");
        });
        modal.querySelector("[data-loop-product-details-minus]")?.addEventListener("click", () => {
            clickActiveProductDetailsControl("decrease");
        });
        modal.querySelector("[data-loop-product-details-plus]")?.addEventListener("click", () => {
            clickActiveProductDetailsControl("increase");
        });
        modal.querySelector("[data-loop-product-details-status]")?.addEventListener("click", () => {
            if (getDisplayedProductDetailsQuantity() > 0) return;
            clickActiveProductDetailsControl("increase");
        });
        return modal;
    };

    const closeProductDetailsModal = () => {
        const modal = document.querySelector("[data-loop-product-details-modal]");
        if (!modal) return;
        modal.hidden = true;
        document.documentElement.classList.remove("loop-product-details-open");
    };

    const setProductDetailsModalState = (state, card = null) => {
        if (card) activeProductDetailsCard = card;
        const modal = ensureProductDetailsModal();
        const title = modal.querySelector("[data-loop-product-details-title]");
        const price = modal.querySelector("[data-loop-product-details-price]");
        const nutrition = modal.querySelector("[data-loop-product-details-nutrition]");
        const description = modal.querySelector("[data-loop-product-details-description]");
        const ingredients = modal.querySelector("[data-loop-product-details-ingredients]");
        const image = modal.querySelector("[data-loop-product-details-image]");
        const link = modal.querySelector("[data-loop-product-details-link]");

        title.textContent = state.title || card?.querySelector(".loop-bundle-product-card-title, .loop-selected-variant-title")?.textContent?.trim() || "Product details";
        price.textContent = state.price || card?.querySelector(".loop-discounted-price, .loop-selected-variant-price-discount")?.textContent?.trim() || "";
        description.textContent = state.description || "Details are loading.";

        const nutritionItems = Array.isArray(state.nutrition) ? state.nutrition.filter((item) => item.value) : [];
        if (nutritionItems.length) {
            nutrition.innerHTML = nutritionItems
                .map((item) => `<span><strong>${escapeHtmlLoopDetails(item.value)}</strong><small>${escapeHtmlLoopDetails(item.label)}</small></span>`)
                .join("");
            nutrition.hidden = false;
        } else {
            nutrition.innerHTML = "";
            nutrition.hidden = true;
        }

        const ingredientGroups = Array.isArray(state.ingredients)
            ? state.ingredients.filter((group) => group.value)
            : [];
        if (ingredientGroups.length) {
            ingredients.innerHTML = ingredientGroups
                .map((group) => `
                    <section>
                        <h3>${escapeHtmlLoopDetails(group.label)}</h3>
                        <p>${escapeHtmlLoopDetails(group.value).replace(/\|\|/g, "<br>")}</p>
                    </section>
                `)
                .join("");
            ingredients.hidden = false;
        } else {
            ingredients.innerHTML = "";
            ingredients.hidden = true;
        }

        if (state.image) {
            image.src = state.image;
            image.alt = state.title || "";
            image.hidden = false;
        } else {
            image.removeAttribute("src");
            image.alt = "";
            image.hidden = true;
        }

        if (state.url) {
            link.href = state.url;
            link.hidden = false;
        } else {
            link.hidden = true;
        }

        syncProductDetailsActionState();
        modal.hidden = false;
        document.documentElement.classList.add("loop-product-details-open");
        modal.querySelector(".loop-product-details-modal__close")?.focus({ preventScroll: true });
    };

    const fetchProductDetails = async (handle) => {
        if (productDetailsCache.has(handle)) return productDetailsCache.get(handle);
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
            headers: { Accept: "application/json" },
        });
        if (!response.ok) throw new Error(`Product details failed with status ${response.status}`);
        const product = await response.json();
        productDetailsCache.set(handle, product);
        return product;
    };

    const fetchProductMetaDetails = async (handle) => {
        if (productMetaDetailsCache.has(handle)) return productMetaDetailsCache.get(handle);
        const response = await fetch(`/products/${encodeURIComponent(handle)}?view=ygb-meta`, {
            headers: { Accept: "application/json, text/plain, */*" },
        });
        if (!response.ok) throw new Error(`Product meta details failed with status ${response.status}`);
        const responseText = await response.text();
        const result = JSON.parse(responseText);
        if (!result?.success) throw new Error("Product meta details returned no data");
        productMetaDetailsCache.set(handle, result);
        return result;
    };

    const fetchProductPageDetails = async (handle) => {
        if (productPageDetailsCache.has(handle)) return productPageDetailsCache.get(handle);
        const response = await fetch(`/products/${encodeURIComponent(handle)}`, {
            headers: { Accept: "text/html" },
        });
        if (!response.ok) throw new Error(`Product page failed with status ${response.status}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const descriptionElement =
            doc.querySelector(".product__description") ||
            doc.querySelector('[itemprop="description"]') ||
            doc.querySelector("[data-product-description]");
        const metaDescription = doc.querySelector('meta[name="description"]')?.getAttribute("content") || "";
        const details = {
            description: descriptionElement?.textContent?.replace(/\s+/g, " ").trim() || metaDescription.trim(),
        };
        productPageDetailsCache.set(handle, details);
        return details;
    };

    const getProductImage = (product, fallback = "") => {
        if (product?.featured_image) return product.featured_image;
        if (Array.isArray(product?.images) && product.images.length) return product.images[0];
        return fallback;
    };

    const getVariantPrice = (product, variantId, fallback = "") => {
        const variants = Array.isArray(product?.variants) ? product.variants : [];
        const variant = variants.find((item) => String(item.id) === String(variantId)) || variants[0];
        if (!variant || typeof variant.price === "undefined") return fallback;
        return formatMoneyFromCents(variant.price);
    };

    const getProductTags = (product, productMeta = null) => {
        const metaTags = Array.isArray(productMeta?.tags) ? productMeta.tags : [];
        const productTags = Array.isArray(product?.tags)
            ? product.tags
            : String(product?.tags || "").split(",");
        return [...metaTags, ...productTags]
            .map((tag) => String(tag || "").trim())
            .filter(Boolean)
            .filter((tag, index, tags) => tags.findIndex((item) => item.toLowerCase() === tag.toLowerCase()) === index);
    };

    const buildFallbackProductDescription = (product, productMeta = null) => {
        const tags = getProductTags(product, productMeta);
        const visibleTags = tags.filter((tag) => !/regular|default title/i.test(tag));
        if (visibleTags.length) return visibleTags.slice(0, 5).join(" · ");
        const type = String(product?.type || productMeta?.categoryType || "").trim();
        if (type) return type;
        return "";
    };

    const getCardFallbackDescription = (card, title = "") => {
        const type = String(card?.dataset?.productType || "").trim();
        if (type) return type;

        const handle = String(card?.dataset?.productHandle || "")
            .replace(/-regular$/i, "")
            .replace(/-/g, " ")
            .trim();
        const titleText = String(title || "").trim();
        const baseText = handle || titleText;
        if (!baseText) return "Fresh prepared meal. More details are available on the product page.";

        return `${baseText.replace(/\b\w/g, (letter) => letter.toUpperCase())} meal.`;
    };

    const formatMacroLineValue = (value, suffix = "") => {
        const normalizedValue = String(value || "").trim();
        if (!normalizedValue) return "";
        if (!suffix || normalizedValue.toLowerCase().endsWith(suffix.toLowerCase())) return normalizedValue;
        return `${normalizedValue}${suffix}`;
    };

    const setLoopCardMetaOverlay = (card, productMeta) => {
        if (!card || !productMeta || card.dataset.loopMetaOverlayReady === "true") return;

        const protein = formatMacroLineValue(productMeta.protein, "g");
        const carbs = formatMacroLineValue(productMeta.carbs, "g");
        const calories = String(productMeta.calories || "").trim();
        if (!protein && !carbs && !calories) return;

        const media =
            card.querySelector(".loop-bundle-product-image-container") ||
            card.querySelector(".loop-image-product-lg") ||
            card.querySelector(".loop-card-header");

        if (media && protein && !card.querySelector(".loop-card-protein-overlay")) {
            media.insertAdjacentHTML(
                "afterbegin",
                `<div class="loop-card-protein-overlay"><strong>${escapeHtmlLoopDetails(protein)}</strong><span>Protein</span></div>`
            );
        }

        const title = card.querySelector(".loop-bundle-product-card-title");
        if (title && !card.querySelector(".loop-card-macro-line")) {
            const macroParts = [
                protein ? `${protein} P` : "",
                carbs ? `${carbs} C` : "",
                calories ? `${calories} cal` : "",
            ].filter(Boolean);

            if (macroParts.length) {
                title.insertAdjacentHTML(
                    "afterend",
                    `<p class="loop-card-macro-line">${escapeHtmlLoopDetails(macroParts.join(" · "))}</p>`
                );
            }
        }

        card.dataset.loopMetaOverlayReady = "true";
    };

    const hydrateLoopCardMetaOverlays = () => {
        document.querySelectorAll(".loop-bundle-product-card[data-product-handle]").forEach((card) => {
            if (card.dataset.loopMetaOverlayRequested === "true") return;
            const handle = String(card.dataset.productHandle || "").trim();
            if (!handle) return;

            card.dataset.loopMetaOverlayRequested = "true";
            fetchProductMetaDetails(handle)
                .then((productMeta) => setLoopCardMetaOverlay(card, productMeta))
                .catch(() => {
                    card.dataset.loopMetaOverlayRequested = "";
                });
        });
    };

    const openProductDetails = async (card) => {
        const handle = card?.dataset?.productHandle;
        if (!handle) return;

        const fallbackImage =
            card.querySelector(".loop-img-fit, .loop-selected-variant-info-container img")?.getAttribute("src") || "";
        const fallbackTitle =
            card.querySelector(".loop-bundle-product-card-title, .loop-selected-variant-title")?.textContent?.trim() || "";
        const fallbackPrice =
            card.querySelector(".loop-discounted-price, .loop-selected-variant-price-discount")?.textContent?.trim() || "";

        setProductDetailsModalState({
            title: fallbackTitle,
            price: fallbackPrice,
            description: getCardFallbackDescription(card, fallbackTitle),
            image: fallbackImage,
            url: `/products/${handle}`,
        }, card);

        try {
            const [product, productMeta] = await Promise.all([
                fetchProductDetails(handle),
                fetchProductMetaDetails(handle).catch(() => null),
            ]);
            let productDescription = String(productMeta?.description || "").trim() || stripHtmlLoopDetails(product.description || product.body_html);

            if (!productDescription) {
                try {
                    const pageDetails = await fetchProductPageDetails(handle);
                    productDescription = pageDetails.description;
                } catch (error) {
                    console.error("[Loop Bundle] Unable to load product page description", error);
                }
            }

            productDescription = productDescription || buildFallbackProductDescription(product, productMeta) || getCardFallbackDescription(card, fallbackTitle);

            setProductDetailsModalState({
                title: productMeta?.title || product.title || fallbackTitle,
                price: fallbackPrice || getVariantPrice(product, card.dataset.variantId, fallbackPrice),
                description: productDescription || "Fresh prepared meal. More details are available on the product page.",
                image: productMeta?.image || getProductImage(product, fallbackImage),
                url: productMeta?.url || product.url || `/products/${handle}`,
                nutrition: [
                    { label: "protein", value: formatMacroValueLoopDetails(productMeta?.protein, "g") },
                    { label: "calories", value: productMeta?.calories || "" },
                    { label: "carbs", value: formatMacroValueLoopDetails(productMeta?.carbs, "g") },
                    { label: "fat", value: formatMacroValueLoopDetails(productMeta?.fat, "g") },
                ],
                ingredients: [
                    { label: "Ingredients", value: productMeta?.ingredients || "" },
                    { label: "Allergens / Storage", value: productMeta?.allergensStorage || "" },
                    { label: "Tags", value: productMeta?.ingredients ? "" : getProductTags(product, productMeta).join(" || ") },
                ],
            }, card);
        } catch (error) {
            console.error("[Loop Bundle] Unable to load product details", error);
            setProductDetailsModalState({
                title: fallbackTitle,
                price: fallbackPrice,
                description: getCardFallbackDescription(card, fallbackTitle),
                image: fallbackImage,
                url: `/products/${handle}`,
            }, card);
        }
    };

    const initLoopProductDetails = () => {
        hydrateLoopCardMetaOverlays();

        document.addEventListener("click", (event) => {
            const opener = event.target.closest(
                ".loop-bundle-product-card[data-product-handle] .loop-card-header, .loop-selected-variant-container[data-product-handle] .loop-selected-variant-info-container"
            );
            if (!opener) return;

            const card = opener.closest(".loop-bundle-product-card[data-product-handle], .loop-selected-variant-container[data-product-handle]");
            if (!card) return;

            event.preventDefault();
            event.stopPropagation();
            openProductDetails(card);
        }, true);

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                closeProductDetailsModal();
                return;
            }

            if (event.key !== "Enter" && event.key !== " ") return;
            const opener = event.target.closest(".loop-bundle-product-card[data-product-handle] .loop-card-header");
            if (!opener) return;
            const card = opener.closest(".loop-bundle-product-card[data-product-handle]");
            if (!card) return;

            event.preventDefault();
            event.stopPropagation();
            openProductDetails(card);
        }, true);

        new MutationObserver(hydrateLoopCardMetaOverlays).observe(document.documentElement, {
            childList: true,
            subtree: true,
        });
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initLoopProductDetails, { once: true });
    } else {
        initLoopProductDetails();
    }
})();

(() => {
    const editButtonText = "Edit or Swap Meals";

    const updateLoopLineEditButtons = () => {
        document.querySelectorAll(".loop-line-edit-btn").forEach((button) => {
            if (button.textContent.trim() !== "Edit") return;
            button.textContent = editButtonText;
            button.setAttribute("aria-label", editButtonText);
        });
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", updateLoopLineEditButtons, { once: true });
    } else {
        updateLoopLineEditButtons();
    }

    new MutationObserver(updateLoopLineEditButtons).observe(document.documentElement, {
        childList: true,
        characterData: true,
        subtree: true,
    });
})();

(() => {
    const successText = "Bundle updated successfully";

    const updateLoopSuccessToast = () => {
        document.querySelectorAll("body *").forEach((element) => {
            if (element.classList?.contains("yallah-loop-update-toast")) return;
            if (!element.textContent?.includes(successText)) return;

            const toast =
                element.closest('[role="alert"], [class*="toast"], [class*="Toast"], [class*="notification"], [class*="Notification"]') ||
                element;

            toast.classList.add("yallah-loop-update-toast");
        });
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", updateLoopSuccessToast, { once: true });
    } else {
        updateLoopSuccessToast();
    }

    new MutationObserver(updateLoopSuccessToast).observe(document.documentElement, {
        childList: true,
        subtree: true,
    });
})();
